// extracted by mini-css-extract-plugin
module.exports = {"loaderSmall":"loader_loaderSmall__3vgZX"};